export default "__VITE_ASSET__mGEaL33u__"